import type { SVGProps } from 'react';

export const GoogleLogoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M19.7504 10.2456C19.7504 9.51343 19.6845 8.81284 19.562 8.13916H10.0854V11.9988L15.5432 12C15.3218 13.2842 14.6094 14.3789 13.5179 15.1087V17.6128H16.7666C18.6636 15.869 19.7504 13.2912 19.7504 10.2456Z"
            fill="#4285F4"
        />
        <path
            d="M13.519 15.1088C12.6147 15.7146 11.4501 16.069 10.0877 16.069C7.45602 16.069 5.22347 14.3076 4.42394 11.9333H1.07275V14.5158C2.73304 17.7883 6.14545 20.0339 10.0877 20.0339C12.8125 20.0339 15.1016 19.1439 16.7677 17.6117L13.519 15.1088Z"
            fill="#34A853"
        />
        <path
            d="M4.10832 10.0175C4.10832 9.35087 4.22018 8.70643 4.42389 8.10058V5.51813H1.07271C0.386221 6.87134 0 8.39883 0 10.0175C0 11.6362 0.387398 13.1637 1.07271 14.5169L4.42389 11.9345C4.22018 11.3286 4.10832 10.6842 4.10832 10.0175Z"
            fill="#FABB05"
        />
        <path
            d="M10.0877 3.96491C11.5749 3.96491 12.9067 4.47368 13.9582 5.46783L16.8372 2.61052C15.0886 0.992982 12.809 0 10.0877 0C6.14663 0 2.73304 2.24561 1.07275 5.51812L4.42394 8.10058C5.22347 5.72631 7.45602 3.96491 10.0877 3.96491Z"
            fill="#E94235"
        />
    </svg>
);
